module.exports = __webpack_public_path__ + "img/io-6.035fd6fa.png";